import React, { useState } from "react";
import { X, Plus, Minus, Trash2 } from "lucide-react";

const CartDrawer = ({ open, onClose, items, updateQty, removeItem }) => {
  const total = items.reduce((s, i) => s + i.qty * i.priceValue, 0);

  return (
    <div
      className={`fixed inset-0 z-50 ${open ? "pointer-events-auto" : "pointer-events-none"}`}
      aria-hidden={!open}
    >
      <div
        className={`absolute inset-0 bg-black/50 transition-opacity duration-300 ${open ? "opacity-100" : "opacity-0"}`}
        onClick={onClose}
      />
      <aside
        className={`absolute right-0 top-0 h-full w-full sm:w-[420px] bg-white shadow-2xl flex flex-col transform transition-transform duration-300 ${open ? "translate-x-0" : "translate-x-full"}`}
      >
        <div className="flex items-center justify-between p-5 border-b">
          <div className="font-serif text-xl">Your Bag ({items.length})</div>
          <button onClick={onClose} aria-label="Close cart"><X className="w-5 h-5" /></button>
        </div>

        <div className="flex-1 overflow-y-auto p-5 space-y-4">
          {items.length === 0 && (
            <div className="text-center text-neutral-500 py-16">
              <div className="font-serif text-2xl text-neutral-700 mb-2">Your bag is empty</div>
              <div className="text-sm">Start exploring and add your favorites.</div>
            </div>
          )}
          {items.map((it) => (
            <div key={it.id} className="flex gap-4 border-b pb-4">
              <img src={it.image} alt={it.label} className="w-20 h-24 object-cover rounded-sm" />
              <div className="flex-1">
                <div className="font-medium text-sm">{it.label}</div>
                <div className="text-xs text-neutral-500 mt-1">${it.priceValue.toFixed(2)} each</div>
                <div className="mt-2 flex items-center gap-2">
                  <button onClick={() => updateQty(it.id, it.qty - 1)} className="w-7 h-7 border rounded-sm flex items-center justify-center hover:bg-neutral-100"><Minus className="w-3 h-3" /></button>
                  <span className="text-sm w-6 text-center">{it.qty}</span>
                  <button onClick={() => updateQty(it.id, it.qty + 1)} className="w-7 h-7 border rounded-sm flex items-center justify-center hover:bg-neutral-100"><Plus className="w-3 h-3" /></button>
                  <button onClick={() => removeItem(it.id)} className="ml-auto text-neutral-500 hover:text-[color:var(--brand-red)]"><Trash2 className="w-4 h-4" /></button>
                </div>
              </div>
              <div className="text-sm font-medium">${(it.priceValue * it.qty).toFixed(2)}</div>
            </div>
          ))}
        </div>

        <div className="border-t p-5 space-y-3">
          <div className="flex items-center justify-between text-sm">
            <span className="text-neutral-600">Subtotal</span>
            <span className="font-medium">${total.toFixed(2)}</span>
          </div>
          <div className="text-xs text-neutral-500">Shipping & taxes calculated at checkout.</div>
          <button
            disabled={items.length === 0}
            className="w-full bg-[color:var(--brand-red)] hover:bg-[color:var(--brand-red-dark)] disabled:bg-neutral-300 text-white py-3 text-sm font-semibold uppercase tracking-wider transition-colors"
          >
            Checkout
          </button>
          <button onClick={onClose} className="w-full border border-neutral-300 py-3 text-sm font-medium hover:bg-neutral-50">
            Continue Shopping
          </button>
        </div>
      </aside>
    </div>
  );
};

export default CartDrawer;
